import { render, staticRenderFns } from "./child_productDetails.vue?vue&type=template&id=7ec84e1e&scoped=true"
import script from "./child_productDetails.vue?vue&type=script&lang=js"
export * from "./child_productDetails.vue?vue&type=script&lang=js"
import style0 from "./child_productDetails.vue?vue&type=style&index=0&id=7ec84e1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec84e1e",
  null
  
)

export default component.exports